import React from 'react'
import { 
    Grid,
    Typography,
    Box
} from '@mui/material';
import { makeStyles } from "@mui/styles";
import {getProvinceFromId} from '../data';
import WelderBox from '../../../components/WelderBox'
import RedSeal from '../../../components/RedSeal';
import ListBox from '../../../components/ListBox';
import ArrowBox from '../../../components/ArrowBox';
import {useTranslation} from "react-i18next";


const useStyles = makeStyles((theme) => ({
    root: {
    },
    container: {
        backgroundColor: theme.palette.common.white,
        padding:theme.spacing(1),
    },
}));


const NS = () => {
    const {t} = useTranslation('regulation');
    const classes = useStyles();
    const section1WelderData = [
        {
            title:t('pathways.welderLvl2'), 
            subtitle:`${t('pathways.techTraining')} 210 ${t('pathways.hours')} (7 ${t('pathways.weeks')})`, 
            secondaryTitle:t('pathways.workTraining'),
            secondarySubtitle:t('pathways.accumulateHours'), 
            hours:`5400 ${t('pathways.hours')}`
        },
        {
            title:t('pathways.welderLvl3'), 
            subtitle:`${t('pathways.techTraining')} 210 ${t('pathways.hours')} (7 ${t('pathways.weeks')})`, 
            secondaryTitle:t('pathways.workTraining'),
            secondarySubtitle:t('pathways.accumulateHours'), 
            hours:`5400 ${t('pathways.hours')}`
        },
        
    ];
    const section2WelderData = [
        {
            title:t('pathways.welderLvl1'), 
            subtitle:`${t('pathways.techTraining')} 270 ${t('pathways.hours')} (9 ${t('pathways.weeks')})`, 
            secondaryTitle:t('pathways.workTraining'),
            secondarySubtitle:t('pathways.accumulateHours'), 
            hours:`5400 ${t('pathways.hours')}`
        },
        {
            title:t('pathways.welderLvl2'),
            subtitle:`${t('pathways.techTraining')} 210 ${t('pathways.hours')} (7 ${t('pathways.weeks')})`, 
            secondaryTitle:t('pathways.workTraining'),
            secondarySubtitle:t('pathways.accumulateHours'), 
            hours:`5400 ${t('pathways.hours')}`
        },
        {
            title:t('pathways.welderLvl3'),
            subtitle:`${t('pathways.techTraining')} 210 ${t('pathways.hours')} (7 ${t('pathways.weeks')})`, 
            secondaryTitle:t('pathways.workTraining'),
            secondarySubtitle:t('pathways.accumulateHours'), 
            hours:`5400 ${t('pathways.hours')}`
        },
        
    ];
    const listData = t('pathways.processList3', {returnObjects: true});

    return <>  
        <div className={classes.container}>
            {/**Section 1 */}
            <Box my={8}>
                <Box mb={3} p={1}>
                    <Typography variant="h5" align="center" gutterBottom color="secondary">
                        <b>{t('pathways.NS.section1.title')}</b>
                    </Typography>
                </Box>
                <Grid container justifyContent="center" alignItems="center" spacing={1}> 
                    
                    <ArrowBox>
                        <WelderBox 
                            title={t('pathways.NB.section1.Box1')}
                        />
                    </ArrowBox>

                    {
                        section1WelderData.map((data, idx) => {
                            
                            return (
                                <ArrowBox key={idx}>
                                    <WelderBox                                         
                                        title={data.title}
                                        subtitle={data.subtitle}
                                        secondaryTitle={data.secondaryTitle}
                                        secondarySubtitle={data.secondarySubtitle}
                                        hours={data.hours}
                                    />
                                </ArrowBox>
                            )
                        }
                            
                        )
                    }
                    <RedSeal />
                </Grid>
            </Box>

            {/** Section 2 */}  
            <Box my={8}>
                <Box mb={3} p={1}>
                    <Typography variant="h5" align="center" gutterBottom color="secondary">
                        <b>{t('pathways.NS.section2.title')}</b>
                    </Typography>
                </Box>
                <Grid container justifyContent="center" alignItems="center" spacing={1}> 

                    {
                        section2WelderData.map((data, idx) => {
                            
                            return (
                                <ArrowBox key={idx}>
                                    <WelderBox 
                                        title={data.title}
                                        subtitle={data.subtitle}
                                        secondaryTitle={data.secondaryTitle}
                                        secondarySubtitle={data.secondarySubtitle}
                                        hours={data.hours}
                                    />
                                </ArrowBox>
                            )
                        }
                            
                        )
                    }
                    <RedSeal />
                </Grid>
            </Box>
            {/**Section 3 */}
            <Box my={8}>
                <Box mb={3} p={1}>
                    <Typography variant="h5" align="center" gutterBottom color="secondary">
                        <b>{t('pathways.NS.section3.title')}</b>
                    </Typography>
                    <Typography variant="body1" align="left" gutterBottom>
                        {t('pathways.challExam')}                            
                        <br />
                        {t('pathways.expWorkersText')}
                    </Typography>

                </Box>
                <Grid container justifyContent="center" alignItems="center" spacing={1}> 
                    
                    <ArrowBox >
                    <WelderBox 
                        subtitle={t('pathways.NS.section3.Box1.title')}
                        secondarySubtitle={t('pathways.NS.section3.Box1.body')}
                        maxWidth={"300px"}
                        
                    />
                    </ArrowBox>
                    <ArrowBox >
                    <WelderBox 
                        subtitle={t('pathways.NB.section3.Box2')}
                    />
                    </ArrowBox>
                    <ArrowBox >

                        <ListBox 
                            title={t('pathways.pOfCompProcess')}
                            list={listData}
                            maxWidth={"300px"}
                        />

                        <Box my={6}>
                            <Typography variant="body1" color="secondary">
                                <b>{t('pathways.or')}</b>
                            </Typography>
                        </Box>

                        <WelderBox 
                            subtitle={t('pathways.ticketsHeader')}
                            secondarySubtitle={t('pathways.ticketsBody')}
                            maxWidth={"300px"}
                        />


                    </ArrowBox>
                    


                    <RedSeal/>
                </Grid>
            </Box>
        </div>
       
    </>;
}

export default NS
